let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8ImZB")).then(() => parcelRequire('2OXfw'));